(function () {
  if (window.VMSTvLookup) { window.VMSTvLookup.init(); return; }

  var TIER = {
    pass_2mm: function () { return 'From the manufacturer\'s drawing. Check the hole positions on your TV before drilling.'; },
    flagged_2_5mm: flagged, flagged_5_10mm: flagged, flagged_10_12mm: flagged,
    photo_measured: function (u) { return u == null ? null : 'Estimated from a product photo, about +/- ' + u + ' mm. Verify on your TV before drilling.'; },
    calculated_one_side: function () { return 'One edge is from the maker\'s drawing or a photo; the other is calculated. Verify on your TV before drilling.'; }
  };
  function flagged(u) { return u == null ? null : 'Manufacturer figures, accurate to about +/- ' + u + ' mm. Verify before relying on them.'; }
  function rough(u) { return 'Rough estimate, about +/- ' + (u == null ? 25 : u) + ' mm. Verify on your TV before drilling.'; }
  function tierMessage(row) {
    var f = Object.prototype.hasOwnProperty.call(TIER, row.offset_tier) ? TIER[row.offset_tier] : null;
    var u = num(row.offset_uncertainty_mm) ? row.offset_uncertainty_mm : null;
    return (f && f(u)) || rough(u);
  }

  function has(v) { return v !== null && v !== undefined && v !== ''; }
  function num(v) { return typeof v === 'number' ? isFinite(v) : (typeof v === 'string' && v.trim() !== '' && isFinite(v)); }
  function inch(mm) { return (Number(mm) / 25.4).toFixed(1); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function tag(kind) { try { if (typeof window.clarity === 'function') window.clarity('set', 'vms_tv_lookup', kind); } catch (e) {} }
  var memSid = null;
  function sid() {
    var S = window.VMSSavedTv, s = null, b = new Uint8Array(8), i;
    if (S && typeof S.sid === 'function') return S.sid();
    try { s = window.sessionStorage.getItem('vms:sid'); } catch (e) {}
    if (/^[0-9a-f]{16}$/.test(s || '')) return (memSid = s);
    if (!memSid) {
      try { window.crypto.getRandomValues(b); } catch (e) { for (i = 0; i < 8; i++) b[i] = Math.floor(Math.random() * 256); }
      memSid = '';
      for (i = 0; i < 8; i++) memSid += (b[i] < 16 ? '0' : '') + b[i].toString(16);
    }
    try { window.sessionStorage.setItem('vms:sid', memSid); } catch (e) {}
    return memSid;
  }

  function sizeLabel(row) { return row.model_number + (num(row.screen_size_in) ? ', ' + row.screen_size_in + ' in' : ''); }
  function alnum(t) { return String(t).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function titleClause(row) {
    var parts = [], y = row.model_year;
    if (has(row.series) && alnum(row.model_number).indexOf(alnum(row.series)) === -1) parts.push(String(row.series));
    if (typeof y === 'number' && Math.floor(y) === y && y >= 1990 && y <= 2100) parts.push(String(y));
    return parts.length ? ' (' + parts.join(', ') + ')' : '';
  }

  function parseUrl(x, base) { try { return base ? new URL(String(x), base) : new URL(String(x)); } catch (e) { return null; } }
  var WORDS = { wrong_vesa: 'The VESA pattern (hole spacing) is wrong', wrong_offset: 'The hole position (top or bottom offset) is wrong', wrong_dimensions: 'The size, height or weight is wrong', other: 'Something else' };
  function own(o, k) { return typeof k === 'string' && Object.prototype.hasOwnProperty.call(o, k); }

  function vesaLine(row) {
    var s = row.lookup_status;
    if (s === 'proprietary_mount') return 'This TV uses the maker\'s own mount' + (has(row.proprietary_interface) ? ': ' + row.proprietary_interface : '.');
    if (s === 'not_real_model') return 'We could not confirm this model number exists. Check the label on the back.';
    if (s === 'not_yet_researched') return 'We have this model listed but have not collected its details yet.';
    if (s !== 'vesa_not_found' && has(row.vesa_width_mm) && has(row.vesa_height_mm)) return 'VESA pattern: ' + row.vesa_width_mm + ' x ' + row.vesa_height_mm + ' mm';
    return 'Pattern not published. Measure the hole spacing on the back.';
  }

  function dimsLine(row) {
    var w = row.width_mm, h = row.height_mm, d = row.depth_mm;
    if (num(w) && num(h) && num(d)) return 'Size without stand: ' + inch(w) + ' x ' + inch(h) + ' x ' + inch(d) + ' in (' + w + ' x ' + h + ' x ' + d + ' mm)';
    var parts = [];
    if (num(w)) parts.push('Width without stand: ' + inch(w) + ' in (' + w + ' mm)');
    if (num(h)) parts.push('Height without stand: ' + inch(h) + ' in (' + h + ' mm)');
    if (num(d)) parts.push('Depth without stand: ' + inch(d) + ' in (' + d + ' mm)');
    return parts.length ? parts.join('. ') : null;
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  function pos(v) { return num(v) && Number(v) > 0 ? Number(v) : null; }
  function r1(x) { return Math.round(x * 10) / 10; }
  function mm0(x) { return String(Math.round(Number(x))); }
  function depthText(s) {
    var m = /^\s*(\d+(?:\.\d+)?)\s*(?:mm)?\s*(?:-\s*(\d+(?:\.\d+)?)\s*(?:mm)?)?\s*$/i.exec(String(s));
    if (!m) return String(s);
    return (m[2] && m[2] !== m[1] ? m[1] + ' to ' + m[2] : m[1]) + ' mm';
  }
  function screwText(row) {
    var a = has(row.screw_size) ? String(row.screw_size) : '', b = has(row.screw_depth_range) ? depthText(row.screw_depth_range) : '';
    return a && b ? a + ', depth ' + b : a || (b ? 'Depth ' + b : null);
  }
  function geo(row) {
    row = row || {};
    var vw = pos(row.vesa_width_mm), vh = pos(row.vesa_height_mm);
    if (row.lookup_status !== 'vesa_known' || vw == null || vh == null) return null;
    var W = pos(row.width_mm), H = pos(row.height_mm), D = pos(row.depth_mm);
    var top = num(row.vesa_from_top_mm) && Number(row.vesa_from_top_mm) >= 0 ? Number(row.vesa_from_top_mm) : null;
    var bot = num(row.vesa_from_bottom_mm) && Number(row.vesa_from_bottom_mm) >= 0 ? Number(row.vesa_from_bottom_mm) : null;
    var edges = top != null && bot != null, x0 = 40, y0 = 10, pw = 140, ph, s, mh;
    if (W != null && H != null) { ph = pw * H / W; s = pw / W; }
    else {
      ph = pw * 9 / 16;
      mh = edges ? top + vh + bot : (pos(row.screen_size_in) ? pos(row.screen_size_in) * 25.4 * 9 / Math.sqrt(337) : null);
      s = mh ? ph / mh : pw * 0.4 / vw;
    }
    var hw = vw * s, hh = vh * s, k = Math.min(1, pw * 0.9 / hw, ph * 0.9 / hh);
    hw *= k; hh *= k;
    var cx = x0 + pw / 2, ybot = y0 + ph;
    var yt = edges ? Math.max(y0, Math.min(y0 + top * s, ybot - hh)) : y0 + (ph - hh) / 2;
    var cap = W != null && H != null && D != null ? inch(W) + ' x ' + inch(H) + ' x ' + inch(D) + ' in, back of TV, no stand' : null;
    var name = (has(row.manufacturer) ? row.manufacturer + ' ' : '') + row.model_number;
    var desc = 'Hole pattern ' + vw + ' x ' + vh + ' mm.';
    if (edges) desc += ' Top edge to upper holes ' + inch(top) + ' in (' + mm0(top) + ' mm). Lower holes to bottom edge ' + inch(bot) + ' in (' + mm0(bot) + ' mm).';
    if (cap) desc += ' Size without stand ' + inch(W) + ' x ' + inch(H) + ' x ' + inch(D) + ' in.';
    var h = r1(ybot + (cap ? 26 : 8)), xl = cx - hw / 2, sw = String(vh).length * 8.4;
    var tsy = yt - 15 >= 3 ? yt - 4.5 : yt + 14, vsx = xl - 4.5 - sw >= 29 ? xl - 4.5 : xl + 4.5;
    return { tsy: r1(tsy), vsx: r1(vsx), vsa: vsx < xl ? 'end' : 'start', w: 220, h: h, x0: x0, y0: y0, pw: pw, ph: r1(ph), cx: cx, xl: r1(cx - hw / 2), xr: r1(cx + hw / 2), yt: r1(yt), yb: r1(yt + hh), ybot: r1(ybot), r: 3.2,
      vw: vw, vh: vh, edges: edges, topIn: edges ? inch(top) + ' in' : null, botIn: edges ? inch(bot) + ' in' : null, caption: cap,
      title: 'Back of the ' + name, desc: desc, cropB: r1((h - ybot - 3) / 164 * 100) };
  }
  function cell(label, value, strong) {
    var c = el('div', 'vms-tvl__cell'), list = Array.isArray(value);
    c.appendChild(el('span', 'vms-tvl__cl', label));
    var v = el('span', 'vms-tvl__cv' + (value == null ? ' vms-tvl__nk' : strong ? ' vms-tvl__cvb' : ''), value == null ? 'not known' : list ? value[0] : value);
    if (list) v.appendChild(el('span', 'vms-tvl__cv2', value[1]));
    c.appendChild(v);
    return c;
  }
  function svgEl(tag, a, text) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in a) if (Object.prototype.hasOwnProperty.call(a, k)) n.setAttribute(k, String(a[k]));
    if (text != null) n.textContent = text;
    return n;
  }

  function Widget(root) {
    this.root = root;
    this.endpoint = root.getAttribute('data-endpoint') || '/apps/toolkit/tv-lookup';
    this.showImage = root.getAttribute('data-show-image') === '1';
    this.measureUrl = root.getAttribute('data-measure-url');
    this.mountKind = root.getAttribute('data-mount-kind') || '';
    this.measureAction = root.getAttribute('data-measure-action') === '1';
    this.headTag = root.getAttribute('data-heading-level') === '4' ? 'h4' : 'h3';
    this.phone = root.getAttribute('data-phone-display') || '';
    this.tel = root.getAttribute('data-phone-tel') || '';
    this.hours = root.getAttribute('data-hours') || '';
    this.context = root.getAttribute('data-context') || '';
    this.findUrl = root.getAttribute('data-find-url') || '';
    this.host = root.getAttribute('data-host') || '';
    this.form = root.querySelector('[data-tvl-form]');
    this.input = root.querySelector('[data-tvl-input]');
    this.reported = {};
    this.rid = this.input && this.input.id ? String(this.input.id).replace(/-q$/, '') : 'vms-tvl-' + (++uid);
    this.out = root.querySelector('[data-tvl-out]');
    this.ctrl = null; this.timer = null; this.dwell = null; this.dwellGo = null; this.typed = false; this.cache = {}; this.seq = 0; this.sel = false;
    var self = this;
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.commit(); });
    this.input.addEventListener('input', function () {
      clearTimeout(self.timer); clearTimeout(self.dwell); self.dwell = null;
      var v = self.input.value.trim();
      if (v.length < 2) { self.abort(); self.clear(); return; }
      self.timer = setTimeout(function () { self.lookup(v, false, { typed: true }); }, 300);
    });
  }

  Widget.prototype.commit = function (fallback) {
    clearTimeout(this.timer); clearTimeout(this.dwell); this.dwell = null;
    var v = this.input.value;
    this.lookup(String(v || '').trim().length < 2 && fallback ? fallback : v, true);
  };
  Widget.prototype.abort = function () { this.seq++; clearTimeout(this.dwell); this.dwell = null; if (this.ctrl) { this.ctrl.abort(); this.ctrl = null; } };
  Widget.prototype.unselect = function () {
    if (!this.sel) return;
    this.sel = false;
    this.root.dispatchEvent(new CustomEvent('vms:tv-cleared', { bubbles: true }));
  };
  Widget.prototype.clear = function () { this.out.textContent = ''; this.unselect(); };
  Widget.prototype.show = function (nodes, isCard) {
    clearTimeout(this.dwell); this.dwell = null;
    this.out.textContent = '';
    for (var i = 0; i < nodes.length; i++) this.out.appendChild(nodes[i]);
    if (!isCard) this.unselect();
  };
  Widget.prototype.fail = function (msg) {
    console.warn('vms-tv-lookup: lookup unavailable (' + msg + ')');
    tag('unavailable');
    this.show([el('p', 'vms-tvl__msg', 'Lookup is unavailable for a moment. You can still enter the details by hand.')]);
  };
  Widget.prototype.renderSafe = function (body, explicit, key, prefill) {
    try { this.render(body, explicit, prefill); } catch (e) { delete this.cache[key]; this.fail(e && e.message); return; }
    if (this.context === 'measure') this.respond(body);
  };

  Widget.prototype.respond = function (body) {
    var d = {};
    ['match', 'query', 'catalog_version', 'report_endpoint', 'report_kinds'].forEach(function (k) { d[k] = body[k] === undefined ? null : body[k]; });
    this.root.dispatchEvent(new CustomEvent('vms:tv-response', { bubbles: true, detail: d }));
  };

  Widget.prototype.lookup = function (raw, explicit, opt) {
    var q = String(raw || '').trim();
    if (q.length < 2) return;
    var key = q.toUpperCase(), prefill = !!(opt && opt.prefill);
    var self = this;
    this.abort();
    this.typed = !!(opt && opt.typed);
    if (this.cache[key]) { this.renderSafe(this.cache[key], explicit, key, prefill); return; }
    var seq = this.seq;
    var ctrl = window.AbortController ? new AbortController() : null;
    this.ctrl = ctrl;
    var late = false;
    var slow = setTimeout(function () { if (seq === self.seq) self.show([el('p', 'vms-tvl__msg', 'Looking it up...')], true); }, 400);
    var kill = ctrl ? setTimeout(function () { late = true; ctrl.abort(); }, 8000) : null;
    var url = this.endpoint + (this.endpoint.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q) + (this.host ? '&host=' + encodeURIComponent(this.host) : '') + '&sid=' + sid();
    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        clearTimeout(slow);
        if (res.status === 400) { clearTimeout(kill); return { match: 'none', rows: [], query: q }; }
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (body) {
        clearTimeout(kill);
        if (seq !== self.seq) return;
        self.ctrl = null;
        if (!body || typeof body.match !== 'string' || !Array.isArray(body.rows)) throw new Error('bad body');
        self.cache[key] = body;
        self.renderSafe(body, explicit, key, prefill);
      })
      .catch(function (err) {
        clearTimeout(slow); clearTimeout(kill);
        if (seq !== self.seq || (err && err.name === 'AbortError' && !late)) return;
        self.ctrl = null;
        self.fail(late ? 'timeout' : err && err.message);
      });
  };

  Widget.prototype.render = function (body, explicit, prefill) {
    var self = this, rows = body.rows, m = body.match;
    if (explicit) tag(m);
    if ((m === 'exact' || m === 'merged' || m === 'alias') && rows.length === 1) return this.card(rows[0], body, explicit, prefill);
    if ((m === 'exact' || m === 'merged') && rows.length > 1) return this.card(rows[0], body, explicit, prefill);
    if (m === 'alias' && rows.length > 1) {
      return this.show([
        el('p', 'vms-tvl__lead', 'This number is used for more than one TV. Pick yours:'),
        this.list(rows, function (row) { tag(m); self.card(row, body, true); })
      ]);
    }
    if (m === 'suggestion' && rows.length) {
      return this.show([
        el('p', 'vms-tvl__lead', (body.suggestion_kind === 'near' || body.suggestion_kind === 'shortened_prefix') ? 'We could not find that exact number. Did you mean one of these?' : 'Not an exact match. These are different models:'),
        this.list(rows, function (row) { self.input.value = row.model_number; self.lookup(row.model_number, true); })
      ]);
    }
    if (this.context === 'measure') return this.show([this.callLine(el('p', 'vms-tvl__msg', 'We do not have that model in our list yet. Type the brand below and measure your TV.'))]);
    if (this.measureAction && this.root.getAttribute('data-host') === 'slanted') {
      var sp = el('p', 'vms-tvl__msg', 'We do not have that model in our list yet. ');
      sp.appendChild(this.measureBtn());
      sp.appendChild(document.createTextNode('.'));
      return this.show([this.callLine(sp)]);
    }
    if (this.measureAction) {
      var np = el('p', 'vms-tvl__msg', 'We do not have that model in our list yet. ');
      np.appendChild(this.measureBtn());
      np.appendChild(document.createTextNode(' Or pick your screen size below.'));
      return this.show([this.callLine(np)]);
    }
    var h = this.root.getAttribute('data-host'), nx = h === 'configurator' ? ' Pick your screen size below instead.' : h === 'finder' ? ' Enter the size and VESA pattern by hand below.' : h === 'pdp' ? ' Enter the VESA pattern by hand below.' : '';
    this.show([this.callLine(el('p', 'vms-tvl__msg', 'We do not have that model in our list yet.' + nx))]);
  };

  Widget.prototype.linger = function (d, m) {
    var self = this, host = this.host;
    this.dwellGo = null;
    if (!this.typed || d.explicit || d.prefill || d.lookup_status === 'not_real_model' || !/^(exact|merged|alias)$/.test(m)) return;
    this.dwellGo = function () {
      self.dwell = null;
      var S = window.VMSSavedTv;
      if (S && typeof S.sendChoice === 'function') S.sendChoice(d, host);
      if (S && host === 'pdp' && typeof S.set === 'function') S.set(d, { catalog_version: d.catalog_version });
    };
    this.dwell = setTimeout(this.dwellGo, 1500);
  };
  Widget.prototype.hurry = function () { if (!this.dwell || !this.dwellGo) return; clearTimeout(this.dwell); this.dwellGo(); };

  Widget.prototype.phoneTo = function (p, lead, tail) {
    if (!this.phone || !this.tel) return p;
    var a = el('a', null, this.phone);
    a.href = 'tel:' + this.tel;
    p.appendChild(document.createTextNode(lead));
    p.appendChild(a);
    p.appendChild(document.createTextNode((this.hours ? ' (' + this.hours + ')' : '') + tail));
    return p;
  };
  Widget.prototype.callLine = function (p) { return this.phoneTo(p, ' Or call us at ', ' and we will look it up.'); };

  Widget.prototype.reportTarget = function (body) {
    var loc = window.location;
    if (!loc || typeof body.report_endpoint !== 'string' || !Array.isArray(body.report_kinds)) return null;
    var kinds = body.report_kinds.filter(function (k) { return typeof k === 'string' && k !== '' && k !== 'customer_measurement' && k !== 'wrong_source'; });
    var u = kinds.length ? parseUrl(body.report_endpoint, loc.href) : null;
    if (!u || u.origin !== loc.origin || u.pathname.indexOf('/apps/') !== 0) return null;
    return { href: u.href, kinds: kinds };
  };

  Widget.prototype.reportSlot = function (row, body) {
    var self = this, t = this.reportTarget(body);
    if (!t) return null;
    if (this.reported['m:' + row.model_number]) return el('p', 'vms-tvl__rdone', 'Thanks, we will check it.');
    var b = el('button', 'vms-tvl__report', 'Report a problem with this TV\'s figures');
    b.type = 'button';
    b.addEventListener('click', function () { self.reportForm(b, row, body, t); });
    return b;
  };

  Widget.prototype.reportForm = function (btn, row, body, t) {
    var self = this, id = this.rid, form = el('form', 'vms-tvl__rform'), msg = null;
    form.noValidate = true;
    var kl = el('label', null, 'What is wrong?'); kl.htmlFor = id + '-rkind';
    var sel = el('select', 'vms-tvl__rkind'); sel.id = id + '-rkind';
    var ph = el('option', null, 'Choose one'); ph.value = ''; ph.disabled = true; ph.selected = true;
    sel.appendChild(ph);
    t.kinds.forEach(function (k) { var o = el('option', null, own(WORDS, k) ? WORDS[k] : k.replace(/_/g, ' ')); o.value = k; sel.appendChild(o); });
    var nl = el('label', null, 'Tell us more (optional)'); nl.htmlFor = id + '-rnote';
    var note = el('textarea', 'vms-tvl__rnote'); note.id = id + '-rnote'; note.maxLength = 500; note.rows = 3;
    var bar = el('div', 'vms-tvl__rrow');
    var send = el('button', 'vms-tvl__rsend', 'Send'); send.type = 'submit';
    var cancel = el('button', 'vms-tvl__rcancel', 'Cancel'); cancel.type = 'button';
    bar.appendChild(send); bar.appendChild(cancel);
    [kl, sel, nl, note, bar].forEach(function (n) { form.appendChild(n); });
    function close() { if (send.disabled) return; if (form.parentNode) form.parentNode.replaceChild(btn, form); btn.focus(); }
    function swap(p) { p.tabIndex = -1; if (form.parentNode) form.parentNode.replaceChild(p, form); p.focus(); }
    cancel.addEventListener('click', close);
    form.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(); } });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (send.disabled) return;
      if (!sel.value) {
        if (!msg) { msg = el('p', 'vms-tvl__rmsg', 'Choose what is wrong first.'); msg.id = id + '-rmsg'; msg.setAttribute('role', 'alert'); form.insertBefore(msg, nl); sel.setAttribute('aria-describedby', msg.id); }
        sel.focus();
        return;
      }
      send.disabled = true; cancel.disabled = true;
      var cv = body.catalog_version;
      var done = function (ok) {
        if (ok) { self.reported['m:' + row.model_number] = true; tag('report_sent'); swap(el('p', 'vms-tvl__rdone', 'Thanks, we will check it.')); return; }
        tag('report_failed');
        swap(self.phoneTo(el('p', 'vms-tvl__rfail', 'We could not send that.'), ' Call us at ', '.'));
      };
      if (typeof cv !== 'string' || !cv) return done(false);
      var payload = { tv_id: row.tv_id == null ? null : String(row.tv_id), model_number: row.model_number, catalog_version: cv, kind: sel.value, note: String(note.value || '').trim().slice(0, 500), page: window.location.pathname, ts: new Date().toISOString() };
      try {
        fetch(t.href, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'same-origin' })
          .then(function (r) { done(r.status === 204); }, function () { done(false); });
      } catch (err) { done(false); }
    });
    btn.parentNode.replaceChild(form, btn);
    sel.focus();
  };

  Widget.prototype.measureBtn = function () {
    var root = this.root, b = el('button', 'vms-tvl__measure', 'Enter your TV\'s measurements');
    b.type = 'button';
    b.addEventListener('click', function () { root.dispatchEvent(new CustomEvent('vms:tv-measure', { bubbles: true })); });
    return b;
  };

  Widget.prototype.list = function (rows, onPick) {
    var ul = el('ul', 'vms-tvl__list');
    rows.forEach(function (row) {
      var li = el('li');
      var b = el('button', 'vms-tvl__pick', sizeLabel(row));
      b.type = 'button';
      b.addEventListener('click', function () { onPick(row); });
      li.appendChild(b); ul.appendChild(li);
    });
    return ul;
  };

  Widget.prototype.renderRow = function (row, opt) {
    opt = opt || {};
    if (!row || !has(row.model_number)) return false;
    var q = String(row.model_number), body = { match: 'exact', rows: [row], query: q, catalog_version: has(opt.catalog_version) ? opt.catalog_version : (has(row.catalog_version) ? row.catalog_version : null) };
    clearTimeout(this.timer);
    this.abort();
    this.typed = false;
    this.input.value = q;
    this.cache[q.trim().toUpperCase()] = body;
    this.renderSafe(body, false, q.trim().toUpperCase(), opt.prefill !== false);
    return true;
  };

  Widget.prototype.card = function (row, body, explicit, prefill) {
    if (this.host === 'finder') return this.spec(row, body, explicit, prefill);
    var self = this;
    var card = el('div', 'vms-tvl__card');
    var head = el(this.headTag, 'vms-tvl__title', (has(row.manufacturer) ? row.manufacturer + ' ' : '') + sizeLabel(row) + titleClause(row));
    head.tabIndex = -1;
    card.appendChild(head);
    if (this.showImage && has(row.image_url)) {
      var img = el('img', 'vms-tvl__img');
      img.src = row.image_url; img.alt = 'Back of the ' + row.model_number; img.loading = 'lazy';
      card.appendChild(img);
    }
    card.appendChild(el('p', 'vms-tvl__vesa', vesaLine(row)));
    if (num(row.vesa_from_top_mm) && num(row.vesa_from_bottom_mm)) {
      card.appendChild(el('p', 'vms-tvl__line', 'Top edge to upper holes: ' + inch(row.vesa_from_top_mm) + ' in (' + row.vesa_from_top_mm + ' mm). Lower holes to bottom edge: ' + inch(row.vesa_from_bottom_mm) + ' in (' + row.vesa_from_bottom_mm + ' mm).'));
      card.appendChild(el('p', 'vms-tvl__tier', tierMessage(row)));
    } else if (row.lookup_status === 'vesa_known' && this.measureAction && this.root.getAttribute('data-host') === 'slanted') {
      card.appendChild(el('p', 'vms-tvl__tier', (num(row.height_mm) ? 'We know this TV\'s size but not where its' : 'We don\'t know where this TV\'s') + ' mounting holes sit between its top and bottom edges, so measure before you choose a length.'));
      card.appendChild(this.measureBtn());
    } else if (row.lookup_status === 'vesa_known' && this.measureAction) {
      card.appendChild(el('p', 'vms-tvl__tier', 'We don\'t know where this TV\'s mounting holes sit between its top and bottom edges, so the builder cannot place the screen yet.'));
      card.appendChild(this.measureBtn());
    } else if (row.lookup_status === 'vesa_known' && this.context === 'measure') {
      card.appendChild(el('p', 'vms-tvl__tier', 'We don\'t know where this TV\'s mounting holes sit between its top and bottom edges. Measure B on your TV.'));
    } else if (row.lookup_status === 'vesa_known' && this.mountKind !== 'wall') {
      var p = el('p', 'vms-tvl__tier', 'We don\'t know where this TV\'s mounting holes sit between its top and bottom edges. ' + (this.mountKind === 'ceiling' ? 'On a ceiling mount that changes where the screen ends up, so measure before you choose a length: ' : 'On a wall mount that doesn\'t matter, you just hang the mount higher or lower. On a ceiling mount it changes where the TV ends up: '));
      var a = el('a', null, 'how to find where the TV will end up');
      a.href = this.measureUrl;
      p.appendChild(a); p.appendChild(document.createTextNode('.'));
      card.appendChild(p);
    }
    var lines = [dimsLine(row)];
    if (num(row.weight_kg)) lines.push('Weight: ' + (row.weight_kg * 2.20462).toFixed(1) + ' lb (' + Number(row.weight_kg).toFixed(1) + ' kg)');
    if (has(row.screw_size)) lines.push('Screw size: ' + row.screw_size);
    if (has(row.screw_depth_range)) lines.push('Screw depth (as printed): ' + row.screw_depth_range);
    if (row.recessed_vesa === 1) lines.push('Holes are recessed.');
    if (row.needs_spacers === 1) lines.push('Spacers needed.');
    if (row.near_match_status === 'needs_physical_verification') lines.push('Similar model numbers exist. Check the exact number on the label.');
    lines.forEach(function (t) { if (t) card.appendChild(el('p', 'vms-tvl__line', t)); });
    var report = this.reportSlot(row, body);
    if (report) card.appendChild(report);
    if (!explicit && /^(configurator|slanted)$/.test(this.root.getAttribute('data-host'))) {
      var use = el('button', 'vms-tvl__use', 'Use this TV');
      use.type = 'button';
      use.addEventListener('click', function () { self.commit(body.query); });
      card.appendChild(use);
    }
    if (this.findUrl && row.lookup_status === 'vesa_known' && this.context !== 'measure' && /^(pdp|configurator)$/.test(this.root.getAttribute('data-host'))) {
      var find = el('a', 'vms-tvl__find', 'See every mount that fits this TV');
      find.href = this.findUrl + (this.findUrl.indexOf('?') === -1 ? '?' : '&') + 'tvm=' + encodeURIComponent(row.model_number) + (typeof row.screen_size_in === 'number' && isFinite(row.screen_size_in) ? '&size=' + Math.round(row.screen_size_in) : '');
      find.addEventListener('click', function () { self.hurry(); });
      card.appendChild(find);
    }
    var again = el('button', 'vms-tvl__again', 'Not your TV? Search again');
    again.type = 'button';
    again.addEventListener('click', function () { clearTimeout(self.timer); self.abort(); self.clear(); self.input.value = ''; self.input.focus(); });
    card.appendChild(again);
    this.show([card], true);
    if (explicit) head.focus();
    var detail = {};
    for (var k in row) if (Object.prototype.hasOwnProperty.call(row, k)) detail[k] = row[k];
    detail.query = body.query;
    detail.catalog_version = body.catalog_version;
    detail.explicit = explicit === true;
    detail.prefill = prefill === true;
    this.sel = true;
    this.linger(detail, body.match);
    this.root.dispatchEvent(new CustomEvent('vms:tv-selected', { bubbles: true, detail: detail }));
  };

  Widget.prototype.diagram = function (g) {
    if (!document.createElementNS) return null;
    var id = this.rid, svg = svgEl('svg', { 'class': 'vms-tvl__tvback', viewBox: '0 0 ' + g.w + ' ' + g.h, width: '100%', role: 'img', 'aria-labelledby': id + '-dt', 'aria-describedby': id + '-dd', focusable: 'false' });
    var blue = '#2a2ad4', lx = g.x0 - 6, rx = g.x0 + g.pw + 6;
    svg.appendChild(svgEl('title', { id: id + '-dt' }, g.title));
    svg.appendChild(svgEl('desc', { id: id + '-dd' }, g.desc));
    var defs = svgEl('defs', {}), lg = svgEl('linearGradient', { id: id + '-dg', x1: 0, y1: 0, x2: 0, y2: 1 });
    lg.appendChild(svgEl('stop', { offset: 0, 'stop-color': '#ffffff' }));
    lg.appendChild(svgEl('stop', { offset: 1, 'stop-color': '#eef2f9' }));
    defs.appendChild(lg);
    svg.appendChild(defs);
    svg.appendChild(svgEl('rect', { x: g.x0, y: g.y0, width: g.pw, height: g.ph, rx: 3, fill: 'url(#' + id + '-dg)', stroke: '#555', 'stroke-width': 1 }));
    if (g.edges) {
      var e = svgEl('g', { 'class': 'vms-tvl__dedge', stroke: '#555', 'stroke-width': 0.8, fill: 'none' });
      [[lx, g.y0, lx, g.yt], [lx - 3, g.y0, lx + 3, g.y0], [lx - 3, g.yt, lx + 3, g.yt], [rx, g.yb, rx, g.ybot], [rx - 3, g.yb, rx + 3, g.yb], [rx - 3, g.ybot, rx + 3, g.ybot]].forEach(function (l) {
        e.appendChild(svgEl('line', { x1: r1(l[0]), y1: l[1], x2: r1(l[2]), y2: l[3] }));
      });
      e.appendChild(svgEl('line', { x1: r1(lx + 3), y1: g.yt, x2: r1(g.xl - g.r - 1), y2: g.yt, stroke: '#9aa3b5', 'stroke-dasharray': '2 2' }));
      e.appendChild(svgEl('line', { x1: r1(g.xr + g.r + 1), y1: g.yb, x2: r1(rx - 3), y2: g.yb, stroke: '#9aa3b5', 'stroke-dasharray': '2 2' }));
      svg.appendChild(e);
    }
    svg.appendChild(svgEl('line', { x1: g.xl, y1: g.yt, x2: g.xr, y2: g.yt, stroke: blue, 'stroke-width': 0.8 }));
    svg.appendChild(svgEl('line', { x1: g.xl, y1: g.yt, x2: g.xl, y2: g.yb, stroke: blue, 'stroke-width': 0.8 }));
    var holes = svgEl('g', { fill: blue });
    [[g.xl, g.yt], [g.xr, g.yt], [g.xl, g.yb], [g.xr, g.yb]].forEach(function (p) { holes.appendChild(svgEl('circle', { 'class': 'vms-tvl__dhole', cx: p[0], cy: p[1], r: g.r })); });
    svg.appendChild(holes);
    var my = r1((g.yt + g.yb) / 2 + 3);
    svg.appendChild(svgEl('text', { 'class': 'vms-tvl__dl', x: g.cx, y: r1(g.yt - 4.5), 'font-size': 7.5, 'text-anchor': 'middle', fill: blue, 'font-weight': 600 }, g.vw + ' mm'));
    svg.appendChild(svgEl('text', { 'class': 'vms-tvl__ds', x: g.cx, y: g.tsy, 'font-size': 7.5, 'text-anchor': 'middle', fill: blue, 'font-weight': 600 }, String(g.vw)));
    svg.appendChild(svgEl('text', { 'class': 'vms-tvl__dl', x: r1(g.xl - 7), y: my, 'font-size': 7.5, 'text-anchor': 'end', fill: blue, 'font-weight': 600 }, g.vh + ' mm'));
    svg.appendChild(svgEl('text', { 'class': 'vms-tvl__ds', x: g.vsx, y: my, 'font-size': 7.5, 'text-anchor': g.vsa, fill: blue, 'font-weight': 600 }, String(g.vh)));
    if (g.edges) {
      svg.appendChild(svgEl('text', { 'class': 'vms-tvl__dedge', x: r1(lx - 4), y: r1((g.y0 + g.yt) / 2 + 2.5), 'font-size': 7, fill: '#333', 'text-anchor': 'end' }, g.topIn));
      svg.appendChild(svgEl('text', { 'class': 'vms-tvl__dedge', x: r1(rx + 4), y: r1((g.yb + g.ybot) / 2 + 2.5), 'font-size': 7, fill: '#333' }, g.botIn));
    }
    if (g.caption) svg.appendChild(svgEl('text', { 'class': 'vms-tvl__dcap', x: g.cx, y: r1(g.ybot + 17), 'font-size': 7.5, 'text-anchor': 'middle', fill: '#555' }, g.caption));
    return svg;
  };

  Widget.prototype.holesNote = function () {
    var p = el('p', 'vms-tvl__tier', 'We don\'t know where this TV\'s mounting holes sit between its top and bottom edges. On a wall mount that doesn\'t matter, you just hang the mount higher or lower. On a ceiling mount it changes where the TV ends up: ');
    var a = el('a', null, 'how to find where the TV will end up');
    a.href = this.measureUrl;
    p.appendChild(a); p.appendChild(document.createTextNode('.'));
    return p;
  };

  Widget.prototype.spec = function (row, body, explicit, prefill) {
    var self = this, g = geo(row), card = el('div', 'vms-tvl__card vms-tvl__spec');
    var shead = el('div', 'vms-tvl__shead'), sid = el('div', 'vms-tvl__sid');
    sid.appendChild(el('p', 'vms-tvl__eyebrow', 'Your TV'));
    var head = el(this.headTag, 'vms-tvl__title vms-tvl__model', (has(row.manufacturer) ? row.manufacturer + ' ' : '') + row.model_number);
    head.tabIndex = -1;
    head.id = this.rid + '-tv';
    head.setAttribute('translate', 'no');
    sid.appendChild(head);
    var y = row.model_year, sub = [];
    if (num(row.screen_size_in)) sub.push(row.screen_size_in + ' in');
    if (typeof y === 'number' && Math.floor(y) === y && y >= 1990 && y <= 2100) sub.push(String(y));
    if (has(row.series) && alnum(row.model_number).indexOf(alnum(row.series)) === -1) sub.push(String(row.series));
    if (sub.length) sid.appendChild(el('p', 'vms-tvl__sub', sub.join(', ')));
    var change = el('button', 'vms-tvl__change', 'Change');
    change.type = 'button';
    change.setAttribute('aria-describedby', head.id);
    shead.appendChild(sid);
    shead.appendChild(change);
    card.appendChild(shead);
    if (!g) card.appendChild(el('p', 'vms-tvl__vesa', vesaLine(row)));
    var pic = g ? this.diagram(g) : null, top = el('div', pic ? 'vms-tvl__top vms-tvl__top--dia' : 'vms-tvl__top'), stack = el('div', 'vms-tvl__stack');
    if (pic) {
      var dia = el('div', 'vms-tvl__dia');
      dia.setAttribute('style', '--tvl-dmb: -' + g.cropB + '%');
      dia.appendChild(pic);
      top.appendChild(dia);
    }
    var cells = el('div', 'vms-tvl__cells'), offs = num(row.vesa_from_top_mm) && num(row.vesa_from_bottom_mm), lead = pic ? stack : cells;
    if (g) lead.appendChild(cell('VESA pattern', row.vesa_width_mm + ' x ' + row.vesa_height_mm + ' mm', true));
    lead.appendChild(cell('Weight', num(row.weight_kg) ? (row.weight_kg * 2.20462).toFixed(1) + ' lb, ' + Number(row.weight_kg).toFixed(1) + ' kg' : null, true));
    if (pic) { top.appendChild(stack); card.appendChild(top); }
    var w = row.width_mm, h = row.height_mm, d = row.depth_mm, dims = num(w) && num(h) && num(d);
    if (offs) {
      cells.appendChild(cell('Top edge to upper holes', inch(row.vesa_from_top_mm) + ' in, ' + mm0(row.vesa_from_top_mm) + ' mm'));
      cells.appendChild(cell('Lower holes to bottom', inch(row.vesa_from_bottom_mm) + ' in, ' + mm0(row.vesa_from_bottom_mm) + ' mm'));
    }
    cells.appendChild(cell('Screw size', screwText(row)));
    cells.appendChild(cell('Size without stand', dims ? [inch(w) + ' x ' + inch(h) + ' x ' + inch(d) + ' in', mm0(w) + ' x ' + mm0(h) + ' x ' + mm0(d) + ' mm'] : null));
    card.appendChild(cells);
    if (!offs && row.lookup_status === 'vesa_known') card.appendChild(this.holesNote());
    var lines = [dims ? null : dimsLine(row)];
    if (row.recessed_vesa === 1) lines.push('Holes are recessed.');
    if (row.needs_spacers === 1) lines.push('Spacers needed.');
    if (row.near_match_status === 'needs_physical_verification') lines.push('Similar model numbers exist. Check the exact number on the label.');
    lines.forEach(function (t) { if (t) card.appendChild(el('p', 'vms-tvl__line', t)); });
    if (offs) card.appendChild(el('p', 'vms-tvl__tier vms-tvl__disc', tierMessage(row)));
    var links = el('div', 'vms-tvl__links'), report = this.reportSlot(row, body);
    if (report) links.appendChild(report);
    var again = el('button', 'vms-tvl__again vms-tvl__not', 'Not your TV?');
    again.type = 'button';
    links.appendChild(again);
    card.appendChild(links);
    var reset = function () { clearTimeout(self.timer); self.abort(); self.clear(); self.input.value = ''; self.input.focus(); };
    again.addEventListener('click', reset);
    change.addEventListener('click', reset);
    this.show([card], true);
    if (explicit) head.focus();
    var detail = {};
    for (var k in row) if (Object.prototype.hasOwnProperty.call(row, k)) detail[k] = row[k];
    detail.query = body.query;
    detail.catalog_version = body.catalog_version;
    detail.explicit = explicit === true;
    detail.prefill = prefill === true;
    this.sel = true;
    this.linger(detail, body.match);
    this.root.dispatchEvent(new CustomEvent('vms:tv-selected', { bubbles: true, detail: detail }));
  };

  var uid = 0;
  function init() {
    document.querySelectorAll('[data-vms-tvl]').forEach(function (root) {
      if (root.vmsTvl) return;
      root.vmsTvl = new Widget(root);
    });
  }

  window.VMSTvLookup = { init: init, sid: sid };
  window.VMSTvLookup.geo = geo;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
